import { Button } from "../button";
import { LucideIcon } from "lucide-react";
import { cn } from "@gettactic/helpers";

export interface IconButtonProps {
  icon: LucideIcon;
  variant?: keyof typeof variantStyles;
  disabled?: boolean;
  onClick?: () => void;
  "aria-label"?: string;
}

const variantStyles = {
  success: "text-green-600 hover:bg-green-50 hover:text-green-700",
  danger: "text-red-500 hover:bg-red-50 hover:text-red-700",
  neutral: "text-gray-500 hover:bg-gray-50 hover:text-gray-700"
};

export const IconButton = ({
  icon: Icon,
  variant = "neutral",
  disabled,
  onClick,
  "aria-label": ariaLabel,
  ...props
}: IconButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn(
        "h-6 w-6 p-0 opacity-30 transition-opacity duration-100 group-hover:opacity-100",
        variantStyles[variant]
      )}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
      {...props}
    >
      <Icon className="h-3 w-3" />
    </Button>
  );
};
